import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58207860&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58207860",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58207860')) {
      api.createRecord('58207860', component.options)
    } else {
      api.reload('58207860', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58207860&scoped=true", function () {
      api.rerender('58207860', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/setting/text/index.vue"
export default component.exports